;(function () {
  'use strict'

  angular
    .module('contrast.vulnerabilities.trend')
    .factory('VulnerabilityTrendReportFactory', [
      '$http',
      'UserService',
      VulnerabilityTrendReportFactory
    ])

  function VulnerabilityTrendReportFactory($http, UserService) {
    return {
      bulkDelete: bulkDelete,
      bulkEdit: bulkEdit,
      deleteFilter: deleteFilter,
      editFilter: editFilter,
      getSavedFilters: getSavedFilters,
      saveFilter: saveFilter
    }

    function bulkDelete(ids) {
      var data = {
        view_ids: ids
      }

      return $http.delete(UserService.buildAPIUrl('/vulntrend/views/bulk'), {
        data: data,
        headers: { 'Content-Type': 'application/json' }
      })
    }

    function bulkEdit(edited) {
      var data = {
        views: edited
      }

      return $http.put(UserService.buildAPIUrl('/vulntrend/views/bulk'), data)
    }

    function deleteFilter(id) {
      return $http.delete(UserService.buildAPIUrl('/vulntrend/views/' + id))
    }

    function editFilter(id, data) {
      return $http.put(UserService.buildAPIUrl('/vulntrend/views/' + id), data)
    }

    function getSavedFilters() {
      return $http.get(UserService.buildAPIUrl('/vulntrend/views/'))
    }

    function saveFilter(data) {
      return $http.post(UserService.buildAPIUrl('/vulntrend/views'), data)
    }
  }
})()
